"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalHost = exports.Portal = void 0;

var react_1 = __importDefault(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

function Portal(_ref) {
  var portal = _ref.portal,
      children = _ref.children,
      portalKey = _ref.portalKey;

  if (typeof portal !== 'string' && portal.current) {
    return react_dom_1.default.createPortal(children, portal.current, portalKey);
  } else {
    return null;
  }
}

exports.Portal = Portal;

function PortalHost(_ref2) {
  var portal = _ref2.portal;

  if (typeof portal !== 'string') {
    return react_1.default.createElement("div", {
      ref: portal
    });
  } else {
    return null;
  }
}

exports.PortalHost = PortalHost;